document.addEventListener("DOMContentLoaded", function() {
  const counters = document.querySelectorAll(".counter-number");

  const isInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
           rect.bottom >= 0;
  };

  const runCounter = (counter) => {
    const target = +counter.getAttribute("data-target");
    let count = 0;
    const duration = 2000;
    const increment = target / (duration / 16);

    function updateCounter() {
      count += increment;
      if (count < target) {
        counter.textContent = Math.floor(count);
        requestAnimationFrame(updateCounter);
      } else {
        counter.textContent = target;
      }
    }

    updateCounter();
  };

  const handleScroll = () => {
    counters.forEach(counter => {
      if (!counter.classList.contains("counted") && isInViewport(counter)) {
        counter.classList.add("counted");
        runCounter(counter);
      }
    });
  };

  // Run on scroll and on load
  window.addEventListener("scroll", handleScroll);
  handleScroll();
});



// contact us page title float 
import { gsap } from 'gsap';

document.addEventListener("DOMContentLoaded", function() {
    const chars = document.querySelectorAll('.page-title .char');
  if (!chars.length) {
    return;
  }

  const isSmallScreen = window.matchMedia("(max-width: 767.98px)").matches;

    gsap.fromTo(
        chars,
        {
            opacity: 0,
      yPercent: isSmallScreen ? 75 : 120,
            scaleY: 2.3,
            scaleX: 0.7,
            transformOrigin: "50% 0%"
        },
        {
      duration: isSmallScreen ? 0.7 : 0.9,
            opacity: 1,
            yPercent: 0,
            scaleY: 1,
            scaleX: 1,
            ease: "back.inOut(2)",
      stagger: isSmallScreen ? 0.06 : 0.09
        }
    );
});


// floating shapes for contact us page 
document.addEventListener("DOMContentLoaded", () => {
  const contactSection = document.querySelector(".section.contact-page");
  if (!contactSection) {
    return;
  }

  const shapes = gsap.utils.toArray(".floating-shapes-contact .shape");
  if (!shapes.length) {
    return;
  }

  const container = contactSection.querySelector(".container-fluid");
  if (!container) {
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const isMobile = window.matchMedia("(max-width: 767.98px)").matches;
  const isTablet = window.matchMedia("(max-width: 991.98px)").matches;

  const desktopSettings = [
    { 
      from: { x: -containerRect.width, y: 0, rotation: 0 },
      to: { x: -20, y: 50, rotation: -50 }
    },
    { 
      from: { x: containerRect.width, y: 0, rotation: 0 },
      to: { x: 500, y: -50, rotation: -50 }
    },
    { 
      from: { x: containerRect.width, y: containerRect.height, rotation: 0 },
      to: { x: 500, y: 80, rotation: -50 }
    }
  ];

  const tabletSettings = [
    {
      from: { x: -containerRect.width * 0.7, y: 0, rotation: 0 },
      to: { x: -10, y: 30, rotation: -35 }
    },
    {
      from: { x: containerRect.width * 0.7, y: 0, rotation: 0 },
      to: { x: 280, y: -20, rotation: -35 }
    },
    {
      from: { x: containerRect.width * 0.7, y: containerRect.height * 0.6, rotation: 0 },
      to: { x: 260, y: 60, rotation: -35 }
    }
  ];

  const mobileSettings = [
    {
      from: { x: -containerRect.width * 0.45, y: 0, rotation: 0 },
      to: { x: 0, y: 6, rotation: -18 }
    },
    {
      from: { x: containerRect.width * 0.45, y: 0, rotation: 0 },
      to: { x: 0, y: 20, rotation: -18 }
    },
    {
      from: { x: containerRect.width * 0.45, y: containerRect.height * 0.4, rotation: 0 },
      to: { x: -36, y: 40, rotation: -18 }
    }
  ];

  const settings = isMobile ? mobileSettings : (isTablet ? tabletSettings : desktopSettings);

  shapes.forEach((shape, i) => {
    // Set initial state to prevent blink
    gsap.set(shape, { x: 0, y: 0, opacity: 0, rotation: 0 });

    gsap.fromTo(
      shape,
      { x: settings[i].from.x, y: settings[i].from.y, opacity: 0, rotation: settings[i].from.rotation },
      { x: settings[i].to.x, y: settings[i].to.y, opacity: 1, rotation: settings[i].to.rotation, duration: 1.8, ease: "power3.out", delay: i * 0.4 }
    );

    gsap.to(shape, {
      x: `+=${isMobile ? 2 + i : 8 + i * 4}`,
      y: `+=${isMobile ? 1 + i : 10 + i * 3}`,
      rotation: `+=${isMobile ? 18 : 45}`,
      duration: isMobile ? 3 + i * 0.4 : 4 + i,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      delay: 2 + i * 0.2
    });
  });
});

// case studies sticky tabs glass state on scroll
document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelector("#caseStudyTabs.case-study-tabs-sticky");
  if (!tabs) {
    return;
  }

  let initialTop = 0;

  const topOffset = () => {
    const parsed = parseFloat(window.getComputedStyle(tabs).top || "0");
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const refreshInitialTop = () => {
    tabs.classList.remove("is-scrolled-glass");
    initialTop = tabs.getBoundingClientRect().top + window.scrollY;
  };

  const syncGlassState = () => {
    const shouldGlass = window.scrollY >= initialTop - topOffset() - 1;
    tabs.classList.toggle("is-scrolled-glass", shouldGlass);
  };

  refreshInitialTop();
  syncGlassState();

  window.addEventListener("scroll", syncGlassState, { passive: true });
  window.addEventListener("resize", () => {
    refreshInitialTop();
    syncGlassState();
  });
});

